import { render, staticRenderFns } from "./ButtonInputComponent.vue?vue&type=template&id=0c806cb2&scoped=true"
import script from "./ButtonInputComponent.vue?vue&type=script&lang=js"
export * from "./ButtonInputComponent.vue?vue&type=script&lang=js"
import style0 from "./ButtonInputComponent.vue?vue&type=style&index=0&id=0c806cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c806cb2",
  null
  
)

export default component.exports